import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "./Login.css";
import logoImg from "../img/imgLgo.png";


function Login() {
  const [mode, setMode] = useState("login");
  // modos: login | register | reset

  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [passwordActual, setPasswordActual] = useState("");
  const [nuevaPassword, setNuevaPassword] = useState("");
  const [nombreCompleto, setNombreCompleto] = useState("");
  const [mensaje, setMensaje] = useState("");

  const navigate = useNavigate();

  // --- URL BASE (CAMBIAR AQUÍ PARA PRODUCCIÓN O LOCAL) ---
  // Si estás probando en local antes de subir, comenta la de Render y descomenta localhost
  // const BASE_URL = "http://localhost:5000"; 
  // const BASE_URL = "https://gestor-consumo-backend.fly.dev";

    const BASE_URL = "https://gestor-consumo-backend.vercel.app";
  // --- FUNCIÓN PARA CAMBIAR ENTRE LOGIN, REGISTRO Y RESET ---
  const cambiarModo = (nuevoModo: string) => {
    setMode(nuevoModo);
    setMensaje("");
    setPassword("");
    setPasswordActual("");
    setNuevaPassword("");
    if (nuevoModo !== "register") {
      setNombreCompleto("");
    }
  };

  // --- LÓGICA DE JWT Y CONEXIÓN AL BACKEND ---
  const handleSubmit = async () => {
    // 1. Validaciones básicas
    // if (!usuario || !password) {
    //   setMensaje("Por favor completa usuario y contraseña");
    //   return;

    // }

    if (!usuario) return setMensaje("Ingresá tu usuario");

    if (mode === "login" && !password) 
    return setMensaje("Ingresá tu contraseña");

    if (mode === "register" && !nombreCompleto) {
      setMensaje("Por favor ingresa tu nombre completo");
      return;
    }

    if (mode === "reset" && (!passwordActual || !nuevaPassword)) 
        return setMensaje("Completá ambas contraseñas");



    // 2. Definir endpoint
    let endpoint = "/api/login-simple";
    if (mode === "register") endpoint = "/api/registrar";
    if (mode === "reset") endpoint = "/api/change-password";

    // 3. Preparar payload
    // const payload = {
    //   usuario,
    //   password,
    //   ...(mode === "register" && { nombre_completo: nombreCompleto }),
    // };

    let payload: any = {};

    if (mode === "login") {
      payload = { usuario, password };
    }

    if (mode === "register") {
      payload = {
        usuario,
        password,
        nombre_completo: nombreCompleto,
      };
    }

    if (mode === "reset") {
      payload = {
        usuario: usuario,
        password_actual: passwordActual,
        nueva_password: nuevaPassword, // temporal porque solo tenés un input
      };
    }

        // DEBUG: Ver qué estamos enviando exactamente
    console.log("ENVIANDO AL BACKEND:", payload);

    try {
      setMensaje("Iniciando...");
      
      // const res = await fetch(`${BASE_URL}${endpoint}`, {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify(payload),
      // });


      const headers = new Headers();
      headers.append("Content-Type", "application/json");

      const token = localStorage.getItem("token");
      const esRutaPublica = endpoint === "/api/login-simple" || 
                            endpoint === "/api/registrar";


      if (token && !esRutaPublica) {
          headers.append("Authorization", `Bearer ${token}`);
      }

      const res = await fetch(`${BASE_URL}${endpoint}`, {
          method: "POST",
          headers: headers, // fetch acepta el objeto Headers directamente
          body: JSON.stringify(payload),
      });
      const data = await res.json();

    
      // 4. Manejo de Errores del Servidor
      if (!res.ok || data.success === false) {
        setMensaje(data.mensaje || "Error en la operación");
        return;
      }

      // 5. CASO: REGISTRO O RESET (Solo mensaje éxito)
      if (mode === "register" || mode === "reset") {
        alert(mode === "register" ? "Registro exitoso. Iniciá sesión." : "Contraseña restablecida. Iniciá sesión.");
        cambiarModo("login");
        return;
      }

      // 6. CASO: LOGIN EXITOSO (Guardar Token)
      if (mode === "login") {
        if (!data.token) {
            setMensaje("Error: El servidor no devolvió el token.");
            return;
        }

        // GUARDADO SEGURO
        localStorage.setItem("token", data.token);
        localStorage.setItem("usuario", JSON.stringify(data.usuario));

        // REDIRECCIÓN
        navigate("/", { replace: true });
      }

    } catch (error) {
      console.error("Error de conexión:", error);
      setMensaje("No se pudo conectar con el servidor.");
    }
  };


  return (
    <div className="login-split-screen">
      <div className="login-image-side">
        <div className="image-overlay">
          <div className="footer-brand">
            <p className="text-gray-100 ">MyFin<span>trax</span> @LAS. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>

      <div className="login-form-side">
        <div className="form-wrapper">
          <img className="claseLogo" src={logoImg} alt="Logo"></img>
          {/* <h1 className="logo-text">MyFin<span>trax</span></h1> */}
          <div className="form-container">
            <h2>
              {mode === "login" && "HOLA, INICIAR SESIÓN"}
              {mode === "register" && "CREAR CUENTA"}
              {mode === "reset" && "RESTABLECER CONTRASEÑA"}
            </h2>

            {mode === "register" && (
              <input
                placeholder="Nombre completo"
                value={nombreCompleto}
                onChange={(e) => setNombreCompleto(e.target.value)}
                className="input-moderno"
              />
            )}

            <input
              placeholder="Tu nombre de usuario o email"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value.toLowerCase())}
              className="input-moderno"
            />

            {mode === "reset" ? (
              <>
                <input
                  type="password"
                  placeholder="Contraseña actual"
                  value={passwordActual}
                  onChange={(e) => setPasswordActual(e.target.value)}
                  className="input-moderno"
                />
                <input
                  type="password"
                  placeholder="Nueva contraseña"
                  value={nuevaPassword}
                  onChange={(e) => setNuevaPassword(e.target.value)}
                  className="input-moderno"
                />
              </>
            ) : (
              <input
                type="password"
                placeholder="Tu contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-moderno"
              />
            )}

            <button className="btn-continuar" onClick={handleSubmit}>
              CONTINUAR
            </button>

            {mensaje && <p className="error-msg">{mensaje}</p>}

            <div className="links-container">
              {mode === "login" && (
                <>
                  <p className="link-text" onClick={() => cambiarModo("reset")}>
                    ¿Olvidaste tu contraseña?
                  </p>
                  <p className="footer-link">
                    ¿No tenés cuenta? <span onClick={() => cambiarModo("register")}>Registrate</span>
                  </p>
                </>
              )}
              {(mode === "register" || mode === "reset") && (
                <p className="link-text" onClick={() => cambiarModo("login")}>
                  Volver al login
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  }

export default Login;